// HiddenNestChips — "Hidden: external-clients (N)" reveal chips above the
// Documents list. CTSK-522. Hidden state: outlined chip. Revealed state:
// filled chip with a close icon that re-hides the nest.

import { X } from 'lucide-react';
import type { HiddenNestChip } from '../hooks/useHiddenNests.js';

export function HiddenNestChips({
  chips,
  onToggle,
}: {
  chips: HiddenNestChip[];
  onToggle: (slug: string) => void;
}) {
  if (chips.length === 0) return null;
  return (
    <div
      role="group"
      aria-label="Hidden nests"
      style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}
    >
      {chips.map((c) => {
        const n = c.count === null ? '…' : String(c.count);
        const label = c.revealed ? `${c.slug} (${n})` : `Hidden: ${c.slug} (${n})`;
        return (
          <button
            key={c.slug}
            type="button"
            data-testid={`hidden-nest-chip-${c.slug}`}
            aria-pressed={c.revealed}
            aria-label={c.revealed ? `Hide ${c.slug} documents again` : `Show hidden ${c.slug} documents`}
            title={c.revealed ? 'Click to hide these documents again' : 'Click to show these documents'}
            onClick={() => onToggle(c.slug)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              padding: '4px 10px',
              fontSize: 12,
              fontWeight: c.revealed ? 600 : 400,
              borderRadius: 6,
              cursor: 'pointer',
              border: `1px solid ${c.revealed ? 'var(--accent-primary)' : 'var(--border-strong)'}`,
              background: c.revealed ? 'var(--accent-primary)' : 'var(--surface-raised)',
              color: c.revealed ? '#fff' : 'var(--text-primary)',
            }}
          >
            <span>{label}</span>
            {c.revealed && <X size={12} strokeWidth={2.5} aria-hidden />}
          </button>
        );
      })}
    </div>
  );
}
